<template>
  <div class="drop-edit">
    <h2 class="sub-title">Contenu</h2>
    <p class="info">Cliquer sur l'entête d'une colonne pour appliquer un style</p>
    <div class="wrapper-list">
      <vue-custom-scrollbar class="scroll-area" :settings="settings">
        <table class="center table w-100">
          <thead>
            <tr>
              <th></th>
              <th role="header"
                @click="headerClick(headers.COLUMN)"
                :class="{active: activeColumn === headers.COLUMN}"
              >Colonne</th>
              <th role="header"
                @click="headerClick(headers.VALUE)"
                :class="{active: activeColumn === headers.VALUE}"
              >Valeur</th>
              <th></th>
            </tr>
          </thead>
          <draggable tag="tbody" handle=".data-move-action" @change="handleDrag" :list="element.childElements" group="colonneEdit">
            <template v-for="(el, index) in element.childElements">
              <tr :key="el.key">
                <td><font-awesome-icon class="data-move-action" :icon="['fas', 'grip-lines']" /></td>
                <td style="cursor: default;"
                  :class="{active: activeColumn === headers.COLUMN}"
                >
                <span class="d-flex px-2" :style="formatStyle(data.style.column)">{{getFicheInfo().mappedHeaderKeys[el.key]}}</span></td>
                <td contenteditable="true"
                  :ref="`input-${el.key}`"
                  :class="{active: activeColumn === headers.VALUE}"
                  @keyup.exact.enter="handleDataValueChange(el.key)"
                  @blur="handleDataValueChange(el.key)"
                >
                <span class="d-flex px-2" :style="formatStyle(data.style.value)">{{getFicheInfo().espaceData[el.key]}}</span></td>
                <td><b-button class="my-3" @click="deleteData(index)" variant="outline-danger"><font-awesome-icon :icon="['fas', 'trash']" /></b-button></td>
              </tr>
            </template>
          </draggable>
        </table>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import { removeHtmlTag } from '../../../utils/util'
import { headers } from '../ficheConstante'
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    vueCustomScrollbar,
    draggable
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      element: null,
      activeColumn: null,
      headers,
      updatedValue: {},
      deletedData: []
    }
  },
  beforeMount () {
    this.element = this.data
  },
  beforeDestroy () {
    this.$emit('columnChange', null)
    this.$emit('valueChange', {})
  },
  watch: {
    data: {
      handler (newValue) {
        this.element = {...newValue}
      },
      deep: true
    }
  },
  methods: {
    ...mapGetters(['getFicheInfo']),
    handleDataValueChange (key) {
      this.$refs[`input-${key}`][0].blur()
      const { ligne, onglet } = this.getFicheInfo()
      const payload = {
        onglet,
        ligne,
        headerKey: key,
        valeur: removeHtmlTag(this.$refs[`input-${key}`][0].innerHTML).trim()
      }
      this.updatedValue[key] = payload
      this.$emit('valueChange', this.updatedValue)
    },
    deleteData (index) {
      const key = this.element.childElements[index].key
      this.deletedData.push(key)
      this.element.childElements.splice(index, 1)
      this.$emit('deleteData', this.deletedData)
    },
    handleDrag () {
      this.$emit('dropEdit', this.element.childElements)
    },
    headerClick (header) {
      this.activeColumn = header
      this.$emit('columnChange', header)
    },
    formatStyle (style) {
      let res
      switch (style.justifyContent) {
        case 'flex-start':
          res = {...style, textAlign: 'left'}
          break
        case 'center':
          res = {...style, textAlign: 'center'}
          break
        case 'flex-end':
          res = {...style, textAlign: 'right'}
          break
        default:
          res = {...style, textAlign: 'justify'}
          break
      }
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.drop-edit{
  margin-top: 20px;
  width: 100%;
  p.info{
    font-style: italic;
    color: rgba(0, 0, 0, 0.5);
    font-size: 13px;
    text-align: left;
  }
  h2.sub-title{
    margin-top: 30px;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
  }
  .wrapper-list {
    .scroll-area {
      height: 570px;
      margin-right: -15px;
      padding-right: 15px;
    }
    .ps__thumb-x, .ps__thumb-y {
      background-color: #2b3085 !important;
      width: 6px !important;
      right: 0;
      &:hover {
        background-color: #2b3085;
        width: 6px;
      }
    }
    .ps__rail-y {
      display: block;
      width: 8px;
      border: 1px solid #2b3085;
      border-radius: 6px;
    }
  }
  table{
    width: 60%;
    margin: 0 auto;
    table-layout: fixed;
    th{
      background-color: #d2d3e5;
      color: #FFF;
      border: none;
      &[role="header"]{
        cursor: pointer;
      }
      &[role="header"].active{
        border: 1px solid #9395c1;
      }
      &[role="header"]:hover{
        box-shadow: 1px 3px 2px 0px rgba(35, 106, 163, 0.4);
        border: 1px solid black;
      }
    }
    tbody{
      tr:last-child td.active{
        border-bottom: 1px solid #9395c1;
        box-shadow: 0px 3px 2px 0px rgba(35, 106, 163, 0.4);
      }
      td{
        padding: 0;
        position: relative;
        vertical-align: middle;
        width: 100%;
        span{
          height: 100%;
          width: 100%;
          align-items: center;
          overflow: auto;
          flex-wrap: wrap;
        }
        &.active{
          border-left: 1px solid #9395c1;
          border-right: 1px solid #9395c1;
        }
      }
    }
    tfoot{
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/editElementDrop.vue